import apiClient from '@/api/client'

export interface AutoRegistrationRuleResponse {
  id: string
  age_from: number
  age_to: number
  auto_assign_to_class_id: string | null // null = NO REGISTRATION
  skip_if_not_parishioner: boolean
  is_no_registration: boolean
  description?: string | null
  priority: number
  is_active: boolean
  created_at: string
  // Frontend convenience fields (derived)
  class_name?: string | null
}

export interface CreateAutoRegistrationRulePayload {
  age_from: number
  age_to: number
  auto_assign_to_class_id?: string | null
  skip_if_not_parishioner?: boolean
  is_no_registration?: boolean
  description?: string | null
  priority?: number
}

export const autoRegApi = {
  async list(): Promise<AutoRegistrationRuleResponse[]> {
    const { data } = await apiClient.get('/api/v1/auto-registration')
    return data
  },
  async create(payload: CreateAutoRegistrationRulePayload): Promise<AutoRegistrationRuleResponse> {
    const { data } = await apiClient.post('/api/v1/auto-registration', payload)
    return data
  },
  async update(id: string, payload: Partial<CreateAutoRegistrationRulePayload>): Promise<AutoRegistrationRuleResponse> {
    const { data } = await apiClient.put(`/api/v1/auto-registration/${id}`, payload)
    return data
  },
  async remove(id: string): Promise<{ ok: true }> {
    const { data } = await apiClient.delete(`/api/v1/auto-registration/${id}`)
    return data
  },
}



